import { css } from "@emotion/react";
import { Appearance, Mode, Radius, Shadow } from "../types";
import { getAppearanceModeBackground } from "./get-appearance-mode-background";
import { getAppearanceModeColor } from "./get-appearance-mode-color";
import { getRadius } from "./get-radius";
import { getShadow } from "./get-shadow";

export const getBaseAppearanceModeVariables = (type: 'controls' | 'paper') => (
  appearance: Appearance,
  mode: Mode,
  radius: Radius,
  shadow: Shadow
) => {
  const color = getAppearanceModeColor(appearance, mode)

  return css`
    font-family: var(--fontFamilyBase);
    font-weight: inherit;
    -moz-user-focus: ignore;
    box-sizing: border-box;
    text-decoration: none;
    border-width: 0;
    outline: 0;
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
    background-color: ${getAppearanceModeBackground(type)(appearance, mode)};
    color: ${color};
    border: ${appearance === 'outline'
            ? mode !== 'secondary'
                    ? `1px solid ${color}`
                    : '1px solid var(--colorBorder)'
            : undefined
    };
    border-radius: ${getRadius(radius)};
    box-shadow: ${getShadow(shadow)};
  `
}

export const getBaseAppearanceModeVariablesControls = getBaseAppearanceModeVariables('controls')
export const getBaseAppearanceModeVariablesPaper = getBaseAppearanceModeVariables('paper')
